"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspect = inspect;
const compute_depgraph_1 = require("./compute-depgraph");
const lookpath_1 = require("lookpath");
const path = require("path");
// we assume that swift considers folders as packages instead of manifest files
function pathToPosix(fpath) {
    const parts = fpath.split(path.sep);
    parts.pop();
    if (parts.length === 0) {
        return './';
    }
    return parts.join(path.posix.sep);
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function inspect(root, targetFile, options) {
    const swiftPath = await (0, lookpath_1.lookpath)('swift');
    // Review whether we should check for this or for xcode
    // const xctestPath = await lookpath('xctest');
    const filename = targetFile.split(path.sep).slice(-1)[0];
    if (filename !== 'Package.swift') {
        throw new Error(`${filename} is not supported by Swift Package Manager. Please provide with path to Package.swift`);
    }
    if (!swiftPath) {
        throw new Error('The "swift" command is not available on your system. To scan your dependencies in the CLI, you must ensure you have first installed the relevant package manager.');
    }
    const depGraph = await (0, compute_depgraph_1.computeDepGraph)(root, targetFile, options === null || options === void 0 ? void 0 : options.args);
    if (!depGraph) {
        throw new Error('Failed to scan this Swift PM project.');
    }
    return {
        plugin: {
            name: 'snyk-swiftpm-plugin',
            runtime: 'unknown',
            targetFile: `${pathToPosix(targetFile)}Package.swift`,
        },
        dependencyGraph: depGraph,
    };
}
//# sourceMappingURL=index.js.map